import { Link } from "react-router-dom";
import { Sparkles, Info, X } from "lucide-react";
import { useState } from "react";
import { useWs } from "@/context/Auth";
import { useI18n } from "@/i18n/I18n";

export const TrialBanner = () => {
  const { ws, status } = useWs();
  const { t } = useI18n();
  const key = `rangeo_trial_end_seen_${ws?.id}`;
  // Track dismissal per workspace so switching workspace doesn't reuse a stale value
  const [dismissedKey, setDismissedKey] = useState(null);
  const hidden = dismissedKey === key || localStorage.getItem(key) === "1";
  const setHidden = () => setDismissedKey(key);
  if (!ws) return null;
  if (status === "trial") {
    const days = Math.max(1, Math.ceil((new Date(ws.trial_ends_at) - Date.now()) / 86400000));
    return (
      <div data-testid="trial-banner" className="flex items-center justify-between gap-3 bg-gradient-to-r from-amber-400 to-amber-300 px-4 py-2 text-sm text-slate-900">
        <span className="flex items-center gap-2 font-medium"><Sparkles className="w-4 h-4" />{t("trial.banner", { days })}</span>
        <Link to="/plans" data-testid="trial-banner-cta" className="rounded-full bg-slate-900 px-3 py-1 text-xs font-semibold text-white hover:bg-slate-700 transition-colors">{t("trial.upgrade")}</Link>
      </div>
    );
  }
  if (status === "free" && !ws.plan_id && !hidden) {
    return (
      <div data-testid="trial-ended-banner" className="flex items-center justify-between gap-3 bg-slate-900 px-4 py-2 text-sm text-white">
        <span className="flex items-center gap-2"><Info className="w-4 h-4 text-amber-400 shrink-0" />{t("trial.ended")}</span>
        <span className="flex items-center gap-2 shrink-0">
          <Link to="/plans" className="rounded-full bg-amber-400 px-3 py-1 text-xs font-semibold text-slate-900">{t("trial.upgrade")}</Link>
          <button data-testid="trial-ended-dismiss" onClick={() => { localStorage.setItem(key, "1"); setHidden(true); }} aria-label="close"><X className="w-4 h-4" /></button>
        </span>
      </div>
    );
  }
  return null;
};
